import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Slot machine!", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Slots seem to mainly make sense when you want to pass on HTML into existing logic and design. A classic example might be a blog/news site. It's also worth considering slots when you have a lot of props to pass in. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Default Slot")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Exercise on named slots")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Slot demo", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "slot1Input" }, "Text for slot 1", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "slot2Input" }, "Text for slot 2", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { style: {"font-style":"italic"} }, "So this is some italic text that I hardcoded into the slot machine's parent component. It's right between the two slots. I had to add (an unnamed) slot for this though. If there is no slot in the child component it will not display text outside of slot-templates", -1)
const _hoisted_10 = { key: 0 }

import slotsDemo from '../components/SlotsDemo.vue'
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const slot1 = ref('');
const slot2 = ref('');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", null, [
      _createVNode(_component_router_link, { to: "/default-slot" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_router_link, { to: "/slots/exercise" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        id: "slot1Input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((slot1).value = $event)),
        type: "text",
        placeholder: "Type for slot 1"
      }, null, 512), [
        [_vModelText, slot1.value]
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        id: "slot2Input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((slot2).value = $event)),
        type: "text",
        placeholder: "Type for slot 2"
      }, null, 512), [
        [_vModelText, slot2.value]
      ])
    ]),
    _createVNode(slotsDemo, null, {
      slot1: _withCtx(() => [
        (slot1.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(slot1.value), 1))
          : _createCommentVNode("", true)
      ]),
      slot2: _withCtx(() => [
        (slot2.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(slot2.value), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    })
  ]))
}
}

})